var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"loadingAction"},[_vm._v(" 正在加载中，请稍后！ ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }